export * from "./DetailItem";
